import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { ClinicalEvent } from './types';
/** The server pregnancy query remains authoritative; pulled dating commands invalidate it. */
export function useDatingRefresh(organizationId: string, episodeId: string, events: ClinicalEvent[]) {
  const cache = useQueryClient();
  const observed = useRef<{ scope: string; sequence: number }>({ scope: '', sequence: 0 });
  const newest = events
    .filter((event) => event.event_type === 'PRENATAL.DATING')
    .reduce((sequence, event) => Math.max(sequence, event.sequence), 0);
  useEffect(() => {
    const scope = JSON.stringify([organizationId, episodeId]);
    if (observed.current.scope !== scope) observed.current = { scope, sequence: 0 };
    if (organizationId && newest > observed.current.sequence) {
      observed.current.sequence = newest;
      void cache.invalidateQueries({ queryKey: ['pregnancies', organizationId] });
    }
  }, [cache, organizationId, episodeId, newest]);
}
